import {shieldSvg as Icon__small__shieldSvg} from '../Icon__small/Icon__small--shield.js'

export var shield = {
  name: 'shield',
  category: 'icon',
  colorable: true,
  svg: Icon__small__shieldSvg,
};
